var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitur3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EFF3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 25V20.6258C35 19.5862 35 19.0663 34.781 18.7469C34.5896 18.4678 34.2933 18.2781 33.9597 18.2214C33.5779 18.1564 33.1059 18.3742 32.1619 18.8099L21.0738 23.9275C20.2319 24.3161 19.8109 24.5104 19.5026 24.8117C19.2301 25.0781 19.022 25.4032 18.8944 25.7623C18.75 26.1685 18.75 26.6321 18.75 27.5594V33.75M35.625 33.125H35.6375M18.75 29L18.75 37.25C18.75 38.6502 18.75 39.3502 19.0225 39.885C19.2622 40.3554 19.6446 40.7379 20.115 40.9775C20.6498 41.25 21.3499 41.25 22.75 41.25H37.25C38.6501 41.25 39.3502 41.25 39.885 40.9775C40.3554 40.7379 40.7378 40.3554 40.9775 39.885C41.25 39.3502 41.25 38.6502 41.25 37.25V29C41.25 27.5999 41.25 26.8998 40.9775 26.3651C40.7378 25.8946 40.3554 25.5122 39.885 25.2725C39.3502 25 38.6501 25 37.25 25L22.75 25C21.3499 25 20.6498 25 20.115 25.2725C19.6446 25.5122 19.2622 25.8946 19.0225 26.3651C18.75 26.8998 18.75 27.5999 18.75 29ZM36.25 33.125C36.25 33.4702 35.9702 33.75 35.625 33.75C35.2798 33.75 35 33.4702 35 33.125C35 32.7799 35.2798 32.5 35.625 32.5C35.9702 32.5 36.25 32.7799 36.25 33.125Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitur3);
export default __webpack_public_path__ + "static/media/fitur3.eec57a0f76445599eef1829596e79812.svg";
export { ForwardRef as ReactComponent };